export const STATIC_SHELL_SPLASH_ID = 'shell-splash'
